import { biLogger } from '../biLogger';
import { locale } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ChatbotWarningBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotDisplayWarning: BiEventLogger<ChatbotWarningBiData> = async (
  state,
  { timeWaited, messageText, messageId },
) => {
  const biData = selectBiData(state);
  const { sessionId, chatbotView, contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotDisplayWarning({
    time_waited: timeWaited,
    message_text: messageText,
    message_id: messageId,
    context_uuid: contextBi?.context_uuid,
    context_platform: contextBi?.context_platform,
    user_experience: contextBi?.user_experience,
    mapping_product: contextBi?.mapping_product,
    mapping_url: contextBi?.mapping_url,
    conversation_id: biData.conversationId,
    node_id: biData.nodeId,
    ticket_id: biData.ticketId,
    intent_id: biData.intentId,
    main_option_name: biData.mainOptionName,
    session_id: sessionId,
    chatbot_view: chatbotView,
    lang: locale,
    user_intent: undefined,
    previous_node_id: undefined,
    node_name: undefined,
    previous_node_name: undefined,
    widget_view_mode: undefined,
    num_of_messages: undefined,
    sites_count: undefined,
    selected_account: undefined,
    button_id_list: undefined,
    node_type_id: undefined,
    node_type: undefined,
    input_type: undefined,
    button_name_list: undefined,
    user_response_type: undefined,
  });
};
